import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
    AssessmentMatrixComponent,
    LibraryCreationComponent,
    ManageComponent,
    RiskRegisterComponent
} from 'sms-dashboard';
import { SafetyStateService } from '../safety-state.service';

@Component({
    selector: 'ff-safety-dashboard',
    standalone: true,
    imports: [
        CommonModule,
        RiskRegisterComponent,
        AssessmentMatrixComponent,
        ManageComponent,
        LibraryCreationComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        @switch (state.selectedSection()) {
            @case ('risk-register') {
                <sms-risk-register />
            }
            @case ('assessment-matrix') {
                <sms-assessment-matrix />
            }
            @case ('manage') {
                <sms-manage />
            }
            @case ('library') {
                <sms-library-creation />
            }
        }
    `,
    styles: [
        `
            :host {
                display: block;
                height: 100%;
                overflow-y: auto;
                padding: 60px 25px 25px;
            }
        `
    ]
})
export class SafetyDashboardComponent {
    protected readonly state = inject(SafetyStateService);
}
